import React from 'react';
import HairTip from './Category/HairTip';
import BottonPushes from './Shared/BottonPushes';
import Breadcrumbs from "./Header/Breadcrumbs";
import shortid from "shortid";
import Picture from './Shared/Picture';

class CategoryPageContent extends React.Component {
    constructor(props) {
        super(props);
    }
    isBreadcrumb = () => {
        const object = {}
        if (this.props.breadcrumbs) {
            object.breadcrumbProps = this.props.breadcrumbs.Breadcrumb;
        }
        return object;
    };

    render() {
        const breadcrumbProps = this.isBreadcrumb();
            return (
            <div>
                {this.props.Model.Model.Banner !== null && this.props.Model.Model.Banner.BannerImage.Value ? (
                    <Picture src={this.props.Model.Model.Banner.BannerImage.Value} alt={this.props.Model.Model.Banner.BannerImageAlt.Value}></Picture>
                ) : null }
                <Breadcrumbs {...breadcrumbProps} />
                <div className="main">
                    <h1 dangerouslySetInnerHTML={{"__html": this.props.Model.Model.PageH1.Value }}/>
                    <span dangerouslySetInnerHTML={{"__html": this.props.Model.Model.PageDescription.Value }} className="caringForYourHair-description"/>
                    {this.props.Model.Model.HairSteps ? (
                        <section>
                            <div className="caringForYourHair">
                                {this.props.Model.Model.HairSteps.map((step) => {
                                    return <HairTip key={shortid.generate()} step={step}/>
                                })}
                            </div>
                        </section>
                    ) : null}
                    {this.props.Model.Model.Blogs ? (
                        <section>
                            <div className="caringForYourHair blogs">
                                {this.props.Model.Model.Blogs.map((step) => {
                                    return <HairTip key={shortid.generate()} step={step}/>
                                })}
                            </div>
                        </section>
                    ) : null}
                    {this.props.Model.Model.BottomTiles.length > 0 && (
                        <BottonPushes salonFinder={this.props.Model.Model} bottonPushes={this.props.Model.Model.BottomTiles} salonCountries={this.props.salonCountries}/>
                    )}
                </div>
            </div>
        )
    }
}

export default CategoryPageContent
